import { EDA_URL, EDARU_URL, FLEET_URL } from './constants.js'

const fleetCta = {
  label: 'Открыть анкету подключения',
  href: FLEET_URL,
  event: 'fleet_click',
  external: true,
}

const helpCta = {
  label: 'Задать вопрос парку',
  href: 'https://t.me/abgroupp_bot',
  event: 'telegram_click',
  external: true,
  kind: 'secondary',
}

export const redirectMap = Object.freeze({
  '/curier': '/dostavka',
  '/manual': '/instructions',
  '/manprof': '/instructions/yandex-pro',
  '/yauzb': '/uz',
  '/page13': '/privacy',
  '/page14': '/offer',
})

export const retiredPaths = Object.freeze(['/ozon', '/dostavista'])

export const pages = [
  {
    path: '/alex',
    navLabel: 'Работа с ABG',
    title: 'Работа курьером или в такси через ABG — подключение и помощь',
    description: 'Курьером или водителем через парк ABG: моментальные выплаты, форма Яндекса и помощь Александра при подключении. Выбери доставку или такси.',
    eyebrow: 'Парк ABG · поможет Александр',
    h1: 'Курьером или в такси? Начни с ABG.',
    lead: 'Выбери доставку или такси, заполни форму Яндекса и получи помощь Александра, если застрянешь на подключении.',
    layout: 'alex',
  },
  {
    path: '/',
    navLabel: 'Главная',
    title: 'ABG Taxi — подключение водителей и курьеров',
    description: 'ABG Taxi помогает водителям и курьерам выбрать маршрут, подключиться к заказам и получить понятные инструкции после регистрации.',
    eyebrow: 'Парк ABG Taxi · работаем по России',
    h1: 'Выберите, как хотите выйти на линию',
    lead: 'Не будем грузить всеми вариантами сразу. Сначала выберите маршрут — водитель или курьер. Дальше покажем документы, порядок подключения и что делать после анкеты.',
    layout: 'home',
    routes: [
      {
        number: '01',
        title: 'Работать водителем',
        text: 'Такси и автодоставка: личный автомобиль, документы, подключение через парк и инструкция по Яндекс Про.',
        href: '/taxi',
        event: 'route_select_taxi',
        action: 'Проверить маршрут водителя',
      },
      {
        number: '02',
        title: 'Работать курьером',
        text: 'Пешком, на велосипеде или автомобиле: сравните форматы и выберите подходящий сервис без путаницы.',
        href: '/dostavka',
        event: 'route_select_courier',
        action: 'Проверить маршрут курьера',
      },
    ],
    facts: [
      ['Оператор', 'ООО «АБ ГРУПП»'],
      ['Помощь', 'ежедневно, через мессенджеры'],
      ['Регистрация', 'во внешней официальной форме Fleet'],
    ],
    steps: [
      ['Выберите формат', 'Сопоставьте транспорт, город и то, сколько времени готовы быть на линии.'],
      ['Подготовьте документы', 'На странице маршрута есть короткий список без лишних справок.'],
      ['Заполните анкету', 'Переходите только в тот внешний интерфейс, который указан для выбранного сервиса.'],
      ['Получите инструкцию', 'После подключения возвращайтесь в раздел для партнёров: там первый выход и типовые ошибки.'],
    ],
    faq: [
      ['Это сайт Яндекса?', 'Нет. Это сайт партнёра ABG Taxi, оператор — ООО «АБ ГРУПП». Анкета водителя открывается во внешней форме Fleet Яндекса.'],
      ['Можно сначала задать вопрос?', 'Да. Напишите парку в Telegram или WhatsApp и укажите город, транспорт и выбранный формат.'],
      ['Вы гарантируете конкретный доход?', 'Нет. Доход зависит от города, времени на линии, тарифа, спроса, расходов и условий сервиса. Мы не публикуем неподтверждённые обещания.'],
    ],
  },
  {
    path: '/taxi',
    navLabel: 'Водителям',
    title: 'Работа водителем Яндекс Такси через парк ABG Taxi',
    description: 'Подключение водителей к Яндекс Такси через парк ABG Taxi: требования к автомобилю, документы, анкета Fleet, расходы и подготовка к первому выходу на линию.',
    eyebrow: 'Партнёрский парк · ABG Taxi',
    h1: 'Работа водителем через парк ABG Taxi',
    lead: 'В такси через ABG Taxi подключаем только самозанятых. Подготовьте водительские документы и проверьте, подходит ли автомобиль в вашем городе. Если СМЗ нет, можно выбрать Яндекс Доставку — у неё отдельная анкета.',
    updated: 'Обновлено 7 сентября 2026 года',
    layout: 'route',
    ctas: [
      { label: 'Есть СМЗ — открыть анкету водителя', href: FLEET_URL, event: 'fleet_click', external: true },
      { label: 'Нет СМЗ — выбрать Доставку', href: '/dostavka', event: 'route_select_courier', kind: 'secondary' },
      helpCta,
    ],
    facts: [
      ['До анкеты', 'проверьте город, автомобиль и документы'],
      ['Для расчёта', 'учтите топливо, мойку, обслуживание, комиссию и налог'],
      ['После анкеты', 'парк проверит подключение, затем вы настроите Яндекс Про'],
    ],
    sections: [
      {
        heading: 'Подойдёт ли вам этот маршрут',
        lead: 'Начинать проще, когда машина уже есть и не требует срочных вложений. Если автомобиль арендованный, оформлен на другого человека или вы не уверены в тарифе, сначала напишите парку — до оплаты аренды и дополнительных услуг.',
        items: [
          ['Автомобиль уже доступен', 'Сверьте модель, год и состояние машины с требованиями выбранного тарифа в своём городе. Они могут различаться.'],
          ['Документы под рукой', 'ФИО водителя и сведения об автомобиле в анкете должны совпадать с документами.'],
          ['Смена помещается в график', 'Прибавьте к работе дорогу до района, заправку, мойку и возвращение домой. Это тоже ваше время.'],
        ],
      },
      {
        heading: 'Что подготовить перед анкетой',
        steps: [
          ['Телефон и документы', 'Понадобятся номер телефона, паспорт, водительское удостоверение и документы на автомобиль.'],
          ['Точные данные автомобиля', 'Заранее посмотрите модель, год выпуска, государственный номер и сведения о владельце.'],
          ['Читаемые фотографии', 'Загружайте документы только в официальную форму или тем способом, который отдельно подтвердил парк.'],
          ['Город и формат работы', 'Укажите город, где действительно будете выходить на линию, и не выбирайте тариф наугад.'],
        ],
      },
      {
        heading: 'Посчитайте не выручку, а остаток',
        lead: 'Сумма в приложении ещё не показывает, сколько осталось у вас. Запишите расходы после каждой тестовой смены — через несколько выходов станет видно, какой район и график имеют смысл.',
        items: [
          ['Топливо или зарядка', 'Считайте расход всей смены, включая дорогу до зоны и возвращение домой.'],
          ['Автомобиль', 'Добавьте мойку, парковку, аренду, обслуживание и небольшой резерв на ремонт.'],
          ['Удержания и налог', 'Проверьте комиссию парка, условия сервиса и свой налоговый режим до того, как оценивать результат.'],
          ['Время без пассажира', 'Ожидание, подача и дорога домой не видны в красивой сумме за заказы, но занимают часы.'],
        ],
      },
      {
        heading: 'Что произойдёт после перехода в Fleet',
        steps: [
          ['Откроется анкета водителя', 'Для подключения в такси через наш парк нужна самозанятость. Заполняйте анкету на странице forms.fleet.yandex.ru.'],
          ['Вы отправите анкету', 'Заполняйте поля без сокращений, если они не совпадают с написанием в документах.'],
          ['Парк проверит подключение', 'Если данных не хватает, парк подскажет, что уточнить. Анкета сама по себе не означает готовность принимать заказы.'],
          ['Вы проверите Яндекс Про', 'До первого заказа сверьте профиль, город, автомобиль, доступные режимы, баланс телефона и заряд.'],
        ],
      },
      {
        heading: 'Что чаще всего задерживает подключение',
        items: [
          ['Данные написаны по-разному', 'Опечатка в ФИО, номере автомобиля или телефоне заставляет возвращаться к анкете.'],
          ['Автомобиль не проверили заранее', 'Окончательные требования зависят от города и тарифа; одна и та же модель может подходить не везде.'],
          ['Документы отправили в случайный чат', 'Не пересылайте полные фото документов, SMS-коды, CVV и пароли в общий мессенджер.'],
          ['На линию вышли без проверки профиля', 'Сначала устраните предупреждения в Яндекс Про, затем включайте рабочий статус.'],
        ],
      },
    ],
    next: [
      ['/instructions/yandex-pro', 'Проверить Яндекс Про перед первым заказом'],
      ['/dostavka', 'Сравнить работу водителем и автокурьером'],
    ],
    faq: [
      ['Можно в такси через ваш парк без самозанятости?', 'Нет, в такси ABG Taxi подключает только самозанятых. Без СМЗ можно выбрать Яндекс Доставку: на странице для курьеров есть отдельная анкета и условия.'],
      ['Можно ли подключиться на своём автомобиле?', 'Можно начать анкету с личным или разрешённым для работы автомобилем. Подходит ли конкретная модель, год и состояние, зависит от города и выбранного тарифа.'],
      ['Если автомобиль не мой?', 'Подготовьте документы на автомобиль и основание, по которому вы им пользуетесь. До анкеты уточните у парка, какие подтверждения потребуются именно в вашей ситуации.'],
      ['Нужно ли приезжать в офис?', 'Подключение можно начать онлайн. Если потребуется осмотр автомобиля или очная проверка, парк сообщит об этом отдельно.'],
      ['Можно работать несколько часов после основной работы?', 'Возможный график зависит от сервиса. Для теста считайте не только часы на линии, но и дорогу до района, ожидание и возвращение домой.'],
      ['Парк гарантирует определённый доход?', 'Нет. Результат зависит от города, спроса, времени на линии, тарифа, приоритета, расходов и условий сервиса.'],
      ['Куда писать, если анкета не открывается?', 'Напишите в Telegram ABG Taxi: укажите город, модель телефона и шаг, на котором остановились. Приложите скриншот без паспортных и банковских данных.'],
    ],
  },
  {
    path: '/dostavka',
    navLabel: 'Курьерам',
    title: 'Яндекс Доставка с СМЗ и без: подключение к парку ABG',
    description: 'Подключитесь к Яндекс Доставке с самозанятостью или без СМЗ. Два вопроса, подходящая анкета и инструкция по Яндекс Про. Для СМЗ — 0% комиссии парка ABG.',
    eyebrow: 'Яндекс Доставка · парк ABG',
    h1: 'Подключиться к Яндекс Доставке',
    lead: 'Пешком, на велосипеде или автомобиле. Выберите свой вариант — получите анкету и понятные шаги до первого заказа.',
    updated: 'Обновлено 7 сентября 2026 года',
    layout: 'route',
    registration: true,
    instructionsEyebrow: 'Выберите транспорт',
    instructionsHeading: 'Как будете доставлять?',
    instructions: [
      {
        number: '01',
        title: 'Пешком',
        text: 'Можно начать без покупки транспорта. Важны плотный район, удобная обувь, погода и расстояние до зоны.',
        href: '#peshkom',
        event: 'delivery_format_select',
      },
      {
        number: '02',
        title: 'На велосипеде',
        text: 'Больше радиус и быстрее перемещение, но нужны исправный велосипед, безопасный маршрут и место для хранения.',
        href: '#na-velosipede',
        event: 'delivery_format_select',
      },
      {
        number: '03',
        title: 'На автомобиле',
        text: 'Проще с дальними адресами и погодой, но нужно вычесть топливо, парковку, обслуживание и дорогу домой.',
        href: '#na-avtomobile',
        event: 'delivery_format_select',
      },
    ],
    facts: [
      ['Нет транспорта', 'начните пешком и проверьте район на одной смене'],
      ['Есть велосипед', 'проверьте тормоза, свет, замок и безопасный маршрут'],
      ['Есть автомобиль', 'сначала посчитайте стоимость километра и простоя'],
    ],
    sections: [
      {
        anchor: 'peshkom',
        heading: 'Пешком: простой старт без покупки транспорта',
        lead: 'Пеший формат подходит, если хочется проверить доставку без аренды и кредита. Лучше начинать там, где рестораны, магазины и получатели находятся близко друг к другу, а до рабочей зоны не нужно ехать через весь город.',
        items: [
          ['Когда удобно', 'Есть два–четыре свободных часа, плотный район рядом и не хочется вкладываться в транспорт до первой выплаты.'],
          ['Что утомляет', 'Длинные переходы, подъёмы, дождь, жара и обратная дорога после смены. Оценивайте не только число заказов, но и самочувствие.'],
          ['Что подготовить', 'Заряженный телефон, пауэрбанк, удобную обувь, воду, одежду по погоде и экипировку, которую требует выбранный сервис.'],
        ],
      },
      {
        anchor: 'na-velosipede',
        heading: 'Велосипед: быстрее, если район подходит',
        lead: 'В плотной застройке велосипед помогает сократить время между точками. Но он не превращает любой район в удобный: лестницы, плохой асфальт, тёмные улицы и отсутствие парковки быстро съедают преимущество.',
        items: [
          ['Когда удобно', 'Велосипед уже есть, вы уверенно ездите и можете безопасно оставить его у ресторана и подъезда.'],
          ['Что посчитать', 'Камеры, свет, замок, расходники, ремонт, хранение и дорогу до района, если до него нельзя доехать своим ходом.'],
          ['Чего не делать', 'Не покупайте дорогой велосипед ради обещаний о доходе. Сначала проверьте формат на доступном транспорте или короткой аренде без долгого договора.'],
        ],
      },
      {
        anchor: 'na-avtomobile',
        heading: 'Автомобиль: больше радиус, но выше расходы',
        lead: 'Автокурьеру проще перевозить несколько отправлений и работать в плохую погоду. При этом пробки, платная парковка, холостой пробег и обслуживание могут сделать большую сумму за смену слабым результатом.',
        items: [
          ['Когда удобно', 'Машина уже доступна, район не заставляет постоянно искать парковку, а дальние маршруты покрывают расходы на дорогу.'],
          ['Что вычесть', 'Топливо или зарядку, мойку, парковку, аренду, обслуживание, налог и километры без заказа.'],
          ['Как проверить', 'Запишите пробег, время от выхода из дома до возвращения и все расходы первой смены. Сравнивайте чистый результат за час.'],
        ],
      },
      {
        heading: 'Как выбрать по своей сегодняшней ситуации',
        items: [
          ['Деньги нужны в ближайшие дни', 'Не покупайте новый транспорт. Выберите самый дешёвый доступный старт и заранее проверьте срок оформления и выплат.'],
          ['Свободны только вечером', 'Считайте дорогу после основной работы и возвращение домой. Короткая смена далеко от дома может оказаться длинной поездкой без оплаты.'],
          ['Опыта нет', 'До первого заказа разберитесь с профилем, поддержкой, маршрутом и действиями при задержке. Скорость придёт после нескольких спокойных смен.'],
          ['Бензин дорогой', 'Сравните автодоставку с пешим или велосипедным форматом в плотном районе, а не с общей суммой чужой смены.'],
          ['Хотите работать рядом с домом', 'Сначала проверьте, есть ли поблизости рабочая зона и спрос. Название города само по себе ничего не говорит о конкретном районе.'],
        ],
      },
      {
        heading: 'Соберите план первой смены',
        steps: [
          ['Выберите окно', 'Назначьте день и время, когда у вас останется запас на дорогу домой и непредвиденную задержку.'],
          ['Проверьте район', 'Посмотрите дорогу до зоны, погоду, рельеф, парковку и безопасный обратный маршрут.'],
          ['Подготовьте телефон', 'Зарядите устройство, возьмите пауэрбанк и проверьте мобильный интернет и геолокацию.'],
          ['Запишите результат', 'Отметьте весь потраченный час, пробег, расходы, усталость и сумму после смены.'],
          ['Решите, повторять ли', 'Только после реального выхода меняйте транспорт, район или продолжительность смены.'],
        ],
      },
      {
        heading: 'Что чаще всего портит первую смену',
        items: [
          ['Транспорт купили заранее', 'Ожидания от доставки ещё не проверены, а платёж или дорогая аренда уже появились.'],
          ['Смотрели только на сумму за заказы', 'Дорога до зоны, ожидание, топливо и возвращение домой остались за рамками расчёта.'],
          ['Не разобрались с приложением', 'Первый же спорный адрес превращается в стресс. До линии сохраните инструкцию и найдите поддержку.'],
          ['Взяли слишком длинную смену', 'Усталость повышает риск ошибки и делает вторую попытку маловероятной. Для проверки формата достаточно ограниченного выхода.'],
        ],
      },
    ],
    next: [
      ['#registration', 'Выбрать анкету Яндекс Доставки'],
      ['/instructions/yandex-pro', 'Разобраться с профилем и выплатами в Яндекс Про'],
      [`${EDARU_URL}/blog/rabota-kurierom-na-avto-2026`, 'Подробно посчитать работу курьером на авто', 'edaru_read_more_click'],
    ],
    faq: [
      ['Можно начать курьером без опыта?', 'Для многих курьерских форматов прошлый опыт не нужен. Но до первого заказа нужно закончить оформление, проверить профиль и понять, куда обращаться при проблеме с заказом.'],
      ['Что выбрать, если своего транспорта нет?', 'Начните с пешего формата в плотном районе. Не берите кредит или длинную аренду, пока не проверили доставку на реальной смене.'],
      ['Пешком или на велосипеде выгоднее?', 'Зависит от района, погоды, расстояний и стоимости велосипеда. Сравните две реальные смены по чистому результату за весь час от выхода из дома до возвращения.'],
      ['Когда имеет смысл работать на автомобиле?', 'Когда доступный радиус и стоимость заказов покрывают топливо, парковку, обслуживание и холостой пробег. Проверить это можно только по своим сменам.'],
      ['Можно работать в Яндекс Доставке без самозанятости?', 'Да, в парке ABG есть отдельная анкета для Доставки без СМЗ. Общая комиссия динамическая — до 12–15% от заказа. Точный процент увидите после первого заказа; со стажем работы комиссия снижается.'],
      ['С самозанятостью комиссия тоже такая?', 'Нет. Для самозанятых в Яндекс Доставке через ABG — 0% комиссии парка и другая анкета. Налог и остальные условия сотрудничества проверяйте отдельно.'],
      ['Где посмотреть условия именно моего города?', 'Выберите город в официальной форме или приложении сервиса. Требования, доступные форматы и экипировка могут различаться даже у соседних городов.'],
    ],
  },
  {
    path: '/podrabotka',
    navLabel: 'Подработка',
    title: 'Подработка водителем или курьером в своём городе',
    description: 'Как выбрать подработку водителем или курьером под свой график, транспорт и расходы. Без обещаний фиксированного дохода и лишних анкет.',
    eyebrow: 'Подработка · решение за несколько минут',
    h1: 'Нужны деньги сейчас — выберите смену, которую потянете',
    lead: 'Подработка полезна, когда она решает денежный вопрос, а не создаёт новый долг. Проверьте время, транспорт и чистый остаток до регистрации.',
    layout: 'route',
    ctas: [
      { label: 'Есть автомобиль', href: '/taxi', event: 'route_select_taxi' },
      { label: 'Хочу доставлять', href: '/dostavka', event: 'route_select_courier', kind: 'secondary' },
    ],
    facts: [
      ['2–4 часа', 'выбирайте плотный район и учитывайте дорогу до него'],
      ['Полная смена', 'планируйте перерывы, питание и обратную дорогу'],
      ['Свой автомобиль', 'вычтите топливо, обслуживание и простой'],
    ],
    sections: [
      {
        heading: 'Быстрая проверка перед анкетой',
        steps: [
          'Назовите сумму, которая нужна, и срок — сегодня, неделя или месяц.',
          'Отметьте часы, когда вы действительно свободны, включая дорогу.',
          'Посчитайте обязательные расходы на выбранный транспорт.',
          'Выберите один маршрут и доведите оформление до конца.',
        ],
      },
    ],
    next: [
      ['/rabota', 'Если нужна не только подработка: сравнить форматы работы'],
      [`${EDARU_URL}/blog/rabota-kurierom-bez-opyta-2026`, 'Первый выход курьером без опыта', 'edaru_read_more_click'],
    ],
    faq: [
      ['Можно выйти только вечером?', 'Зависит от города и сервиса. Вечер часто совпадает с высоким спросом, но гарантировать заказы заранее нельзя.'],
      ['Стоит ли арендовать автомобиль ради подработки?', 'Сначала посчитайте аренду, топливо, комиссию и возможный простой. Не берите фиксированный расход под неподтверждённый поток заказов.'],
    ],
  },
  {
    path: '/eda',
    navLabel: 'Яндекс Еда',
    title: 'Работа курьером Яндекс Еды через партнёра ABG Taxi',
    description: 'Подключение курьером Яндекс Еды через партнёра ABG Taxi: пешком, на велосипеде или авто. Что подготовить, как пройти регистрацию и начать первую смену.',
    eyebrow: 'Партнёр Яндекс Еды · оператор ООО «АБ ГРУПП»',
    h1: 'Работа курьером Яндекс Еды через партнёра ABG Taxi',
    lead: 'Выберите, как будете доставлять, подготовьте данные и переходите к регистрации. Условия зависят от города и типа сотрудничества — окончательный вариант вы увидите во время оформления.',
    updated: 'Обновлено 11 августа 2026 года',
    layout: 'partner',
    ctas: [
      { label: 'Проверить город и начать регистрацию', href: EDA_URL, event: 'eda_click', external: true },
      { label: 'Что будет после анкеты', href: `${EDARU_URL}/blog/chto-delat-posle-registracii-yandeks-eda-2026`, event: 'edaru_read_more_click', external: true, kind: 'secondary' },
    ],
    facts: [
      ['Способ доставки', 'пешком, на велосипеде или автомобиле'],
      ['После анкеты', 'вход в Яндекс Про и подготовка к первому слоту'],
      ['Выплаты', 'срок зависит от типа сотрудничества и реквизитов'],
    ],
    instructionsEyebrow: 'Выберите свой транспорт',
    instructionsHeading: 'Как вы планируете доставлять?',
    instructions: [
      {
        number: '01',
        title: 'Пешком',
        text: 'Не нужны расходы на топливо и ремонт транспорта. Важнее удобный район, обувь, погода и вес заказов.',
        href: '#peshkom',
      },
      {
        number: '02',
        title: 'На велосипеде',
        text: 'Можно проходить больший радиус, но до первой смены проверьте тормоза, свет, замок и крепление сумки.',
        href: '#na-velosipede',
      },
      {
        number: '03',
        title: 'На автомобиле',
        text: 'Проще в плохую погоду и на дальних маршрутах. Из выплаты придётся вычитать топливо, парковку и обслуживание.',
        href: '#na-avtomobile',
      },
    ],
    sections: [
      {
        anchor: 'formaty-dostavki',
        heading: 'Сначала выберите способ доставки',
        lead: 'Лучший транспорт — не самый быстрый на бумаге, а тот, на котором вы сможете спокойно повторить смену завтра. Начните с того, что уже есть, и не покупайте технику до первого реального выхода.',
        items: [
          ['Пешком — если район компактный', 'Подходит для старта без транспорта. Проверьте, сколько времени займёт дорога до зоны и как вы переносите несколько часов на ногах.'],
          ['Велосипед — если готовы следить за техникой', 'Радиус становится больше, но появляются ремонт, хранение и безопасность на дороге. Заряд электровелосипеда тоже входит в план смены.'],
          ['Автомобиль — если пробег окупается', 'Считайте не только бензин. Добавьте парковку, мойку, обслуживание и пустой путь обратно из зоны.'],
        ],
        source: {
          href: 'https://pro.yandex.ru/ru-ru/moskva/knowledge-base/courier',
          label: 'Официальная база знаний Яндекс Про для курьеров',
        },
      },
      {
        anchor: 'peshkom',
        heading: 'Пешком: проще начать, важнее правильно выбрать район',
        lead: 'Пеший формат не требует своего транспорта, но расстояние ощущается сильнее. Для первого выхода удобнее знакомый район, где вы знаете переходы, входы в торговые центры и дворы.',
        steps: [
          ['Посмотрите путь до зоны', 'Время от дома до начала слота — тоже ваше время, хотя отдельной строкой в выплате оно не появится.'],
          ['Проверьте обувь и заряд телефона', 'Телефон нужен для карты, статусов и связи. Павербанк полезнее случайной покупки дорогой экипировки.'],
          ['Оцените смену после выхода', 'Запишите время на ногах, дорогу домой и сумму после личных расходов. Так станет понятно, повторять ли этот формат.'],
        ],
      },
      {
        anchor: 'na-velosipede',
        heading: 'На велосипеде: быстрее между точками, но техника должна быть готова',
        lead: 'Велосипед помогает расширить рабочий радиус. Он не отменяет расходы: даже у своего велосипеда изнашиваются тормоза, цепь и покрышки.',
        steps: [
          ['Проверьте велосипед до слота', 'Тормоза, давление в колёсах, свет и заряд аккумулятора проверяйте дома, а не после первого заказа.'],
          ['Продумайте крепление и хранение', 'Сумка не должна мешать управлению, а замок понадобится у ресторанов и домов клиентов.'],
          ['Не начинайте с длинной смены', 'Сначала проверьте один знакомый район и поймите, хватает ли сил и заряда на обратную дорогу.'],
        ],
      },
      {
        anchor: 'na-avtomobile',
        heading: 'На автомобиле: считайте чистый результат, а не сумму на экране',
        lead: 'Автомобиль защищает от погоды и подходит для дальних маршрутов. Но каждая лишняя подача, платная парковка и пустой возврат уменьшают остаток после смены.',
        steps: [
          ['Запишите пробег до старта', 'Отдельно отметьте путь до зоны, километры с заказами и дорогу домой.'],
          ['Заложите все расходы', 'Топливо видно сразу. Мойка, обслуживание, шины и амортизация проявляются позже, но платить за них всё равно придётся.'],
          ['Сравните с водительским маршрутом', 'Если машина подходит для перевозки пассажиров, откройте страницу такси и сравните документы, нагрузку и расходы.'],
        ],
        note: 'Если пассажирский формат вам ближе, на странице «Работа в такси» есть отдельный маршрут через Fleet ABG Taxi.',
      },
      {
        anchor: 'do-ankety',
        heading: 'Что подготовить до анкеты',
        lead: 'Точный список зависит от возраста, гражданства, города и типа сотрудничества. Не собирайте пакет по чужому сообщению: ориентируйтесь на поля, которые показывает ваш маршрут регистрации.',
        steps: [
          ['Телефон и доступ к аккаунту', 'Укажите номер без ошибки и не передавайте коды входа посторонним.'],
          ['Документы по запросу формы', 'Фотографируйте при хорошем свете: все углы документа видны, данные читаются, нет бликов.'],
          ['Яндекс Про', 'После анкеты приложение понадобится для профиля, слотов, заказов, сообщений и отчётов.'],
          ['Транспорт и экипировка', 'Не покупайте короб или велосипед заранее. Сначала посмотрите, что требуется именно в вашем городе и как проходит получение.'],
        ],
      },
      {
        anchor: 'posle-ankety',
        heading: 'Что будет после отправки анкеты',
        lead: 'Регистрация не заканчивается кнопкой «Отправить». Сохраните статус и пройдите подсказки до момента, когда профиль готов к первому выходу.',
        steps: [
          ['Сохраните страницу и статус заявки', 'Если проверка остановится, вы сможете назвать точный шаг, а не начинать регистрацию заново.'],
          ['Войдите в Яндекс Про', 'Проверьте профиль, сообщения и задания, которые появились для вашего города.'],
          ['Разберитесь с экипировкой', 'Приложение или специалист подскажут, где получить нужную сумку и требуется ли дополнительная проверка.'],
          ['Выберите первый слот', 'Для начала возьмите время и район, которые знаете. Не пытайтесь доказать себе что-то восьмичасовой сменой.'],
        ],
        source: {
          href: 'https://pro.yandex.ru/ru-ru/knowledge-base/courier/sotrudnichestvo/sloty-zakazy',
          label: 'Официально о слотах и заказах в Яндекс Про',
        },
      },
      {
        anchor: 'vyplaty',
        heading: 'Когда приходят деньги и где смотреть расчёт',
        lead: 'Срок выплаты зависит от того, сотрудничаете вы с сервисом напрямую как самозанятый или через парк. Поэтому сначала проверьте тип сотрудничества в своих документах и профиле.',
        items: [
          ['Прямой самозанятый', 'С картой Про выплаты после заказа, бонуса или чаевых могут поступать в течение нескольких минут. Без неё действует другой график, который указан в Яндекс Про.'],
          ['Курьер через парк', 'Условия выплаты определяет парк. Уточняйте комиссию, график и способ вывода до первой длинной смены.'],
          ['Где сверить сумму', 'Откройте раздел денег и отчётов в Яндекс Про. Сравнивайте заказы, бонусы, корректировки и фактическое поступление на карту.'],
        ],
        note: 'Быстрая выплата — не универсальное обещание для каждого профиля. Она зависит от типа сотрудничества, карты и настроек.',
        source: {
          href: 'https://pro.yandex.ru/ru-ru/kotovo/knowledge-base/courier/dohod/payouts-every-day-couriers',
          label: 'Условия карты Про на официальном сайте Яндекс Про',
        },
      },
      {
        anchor: 'pervaya-smena',
        heading: 'План первой смены без лишних покупок',
        steps: [
          ['Выберите знакомую зону', 'Первый выход нужен, чтобы понять приложение и свой темп, а не проверить весь город.'],
          ['Зарядите телефон и транспорт', 'Включите геолокацию, возьмите зарядку или павербанк и проверьте экипировку.'],
          ['Читайте экран заказа', 'Адрес, комментарий и статус меняются по ходу доставки. Если возникла проблема с активным заказом, пишите в поддержку сервиса.'],
          ['Запишите итог', 'Отметьте время, пробег или нагрузку, расходы и сумму после смены. Решение о следующем выходе принимайте по этим данным.'],
        ],
      },
    ],
    next: [
      [`${EDARU_URL}/blog/chto-delat-posle-registracii-yandeks-eda-2026`, 'Что делать после регистрации в Яндекс Еде', 'edaru_read_more_click'],
      [`${EDARU_URL}/blog/eda-vs-kuper-2026`, 'Сравнить Яндекс Еду и Купер', 'edaru_read_more_click'],
      ['/instructions/yandex-pro', 'Проверить профиль и выплаты в Яндекс Про'],
    ],
    faq: [
      ['ABG Taxi — это партнёр Яндекс Еды?', 'Да. Публичной стороной сайта выступает ООО «АБ ГРУПП». Услуги доставки выполняются по условиям выбранного при регистрации маршрута.'],
      ['Почему регистрация открывается на другом сайте?', 'ABG Taxi ведёт на отдельную страницу оформления. Перед вводом данных проверьте адрес, название сервиса и условия, которые показаны на экране.'],
      ['Можно работать пешком, на велосипеде или автомобиле?', 'Такие способы доставки используются в Яндекс Еде. Доступность конкретного формата и города проверьте во время регистрации.'],
      ['Нужна ли самозанятость?', 'Тип сотрудничества выбирается при оформлении: возможна прямая работа как самозанятый или маршрут через партнёра. Условия зависят от города и профиля.'],
      ['Выплаты действительно моментальные?', 'Для прямых самозанятых курьеров с картой Про официальный срок может составлять несколько минут после заказа. У парковых курьеров график и способ вывода определяет парк.'],
      ['Куда обращаться после регистрации?', 'По активному заказу и работе приложения используйте поддержку сервиса. По подключению и условиям парка обращайтесь в ABG Taxi, указав город, телефон профиля и шаг, на котором возник вопрос.'],
    ],
  },
  {
    path: '/kuper',
    navLabel: 'Купер',
    title: 'Работа курьером Купера или Яндекс Еды: что выбрать',
    description: 'Сравните работу курьером Купера и Яндекс Еды по району, транспорту, выплатам и расходам. Почему ABG Taxi предлагает маршрут Яндекс Еды и как подключиться.',
    eyebrow: 'Купер или Яндекс Еда · сравнение перед регистрацией',
    h1: 'Работа курьером Купера или Яндекс Еды: что выбрать',
    lead: 'Если вы пришли за Купером, не спешите открывать первую попавшуюся анкету. Сравните свой район, транспорт, выплаты и поддержку. ABG Taxi предлагает подключение в Яндекс Еду — ниже объясняем почему.',
    updated: 'Обновлено 11 августа 2026 года',
    layout: 'route',
    ctas: [
      { label: 'Почему мы советуем Яндекс Еду', href: `${EDARU_URL}/blog/eda-vs-kuper-2026`, event: 'edaru_read_more_click', external: true },
      { label: 'Проверить маршрут Яндекс Еды', href: '/eda', kind: 'secondary' },
    ],
    facts: [
      ['Купер', 'пешком, велосипед или авто; выплаты раз в неделю'],
      ['Яндекс Еда', 'несколько типов сотрудничества и выплат'],
      ['Маршрут ABG', 'подключение и помощь по Яндекс Еде'],
    ],
    instructionsEyebrow: 'Что для вас важнее?',
    instructionsHeading: 'Сравните сервисы по своей смене',
    instructions: [
      {
        number: '01',
        title: 'Работа рядом с домом',
        text: 'Проверьте, есть ли доступная зона, сколько времени займёт дорога к старту и как возвращаться после смены.',
        href: '#rayon',
      },
      {
        number: '02',
        title: 'Понятные выплаты',
        text: 'Смотрите не слово «быстро», а конкретный график, тип сотрудничества, реквизиты и правила вывода.',
        href: '#vyplaty-kuper-eda',
      },
      {
        number: '03',
        title: 'Быстрый первый выход',
        text: 'Сравните путь от анкеты до приложения, экипировки и первого доступного слота в своём городе.',
        href: '#pochemu-eda',
      },
    ],
    sections: [
      {
        anchor: 'rayon',
        heading: 'Начните с района, а не с рекламной суммы',
        lead: 'Оба сервиса работают в разных городах и зонах. Ваша реальная смена начинается не с первого заказа, а с дороги до места, где можно выйти на доставки.',
        items: [
          ['Зона старта', 'Проверьте доступный район и путь до него. Час дороги в одну сторону может сделать удобный график неудобным.'],
          ['Тип заказов', 'Рестораны, магазины, вес и расстояние различаются. Спросите себя, какой формат вы готовы повторять несколько раз за смену.'],
          ['Возвращение домой', 'Последний заказ может закончиться не там, где началась смена. Для велосипеда и автомобиля это влияет на заряд, топливо и время.'],
        ],
      },
      {
        anchor: 'chto-predlagaet-kuper',
        heading: 'Что Купер заявляет на своей странице для курьеров',
        lead: 'У Купера есть пеший, велосипедный и автомобильный формат. Сервис пишет о выборе района, расписании от нескольких часов и еженедельных выплатах.',
        items: [
          ['Формат', 'Пеший курьер, велокурьер и автокурьер — окончательный вариант зависит от города и доступных позиций.'],
          ['Расписание', 'На публичной странице можно выбрать неполную занятость или более плотную неделю. Реальные смены проверяйте после оформления.'],
          ['Выплаты', 'Купер указывает еженедельный график. Отдельные возможности раннего вывода зависят от статуса и условий программы.'],
        ],
        note: 'ABG Taxi не заявляет партнёрство с Купером. Ссылка на официальный источник дана для честного сравнения, а не как маршрут регистрации через ABG.',
        source: {
          href: 'https://kuper.ru/rabota',
          label: 'Официальная страница работы курьером Купера',
        },
      },
      {
        anchor: 'pochemu-eda',
        heading: 'Почему ABG Taxi предлагает маршрут Яндекс Еды',
        lead: 'Здесь у нас есть понятный путь: регистрация, помощь партнёра, Яндекс Про и отдельная инструкция после анкеты. Человек заранее знает, куда вернуться, если застрянет между оформлением и первой сменой.',
        items: [
          ['Один маршрут вместо нескольких анкет', 'Страница Яндекс Еды сначала помогает выбрать транспорт и подготовиться, а затем открывает действующее оформление.'],
          ['Работа через Яндекс Про', 'В приложении курьер видит слоты, заказы, сообщения, качество и отчёты. По активному заказу доступна поддержка сервиса.'],
          ['Несколько вариантов выплат', 'Условия зависят от типа сотрудничества. Для прямых самозанятых с картой Про подтверждены выплаты после заказа; для паркового маршрута условия задаёт парк.'],
        ],
        source: {
          href: 'https://pro.yandex.ru/ru-ru/moskva/knowledge-base/courier/sotrudnichestvo/tipy-sotrudnichestva',
          label: 'Официально о типах сотрудничества с Яндекс Едой',
        },
      },
      {
        anchor: 'vyplaty-kuper-eda',
        heading: 'Как сравнить выплаты без ловушки в формулировках',
        lead: '«Ежедневно», «моментально» и «раз в неделю» — это ещё не полный ответ. Важны тип сотрудничества, момент расчёта, комиссия, корректировки и банк получателя.',
        steps: [
          ['Откройте условия своего маршрута', 'Не переносите условия из чужого города или другого типа профиля на себя.'],
          ['Уточните, кто перечисляет деньги', 'При прямом сотрудничестве это сервис, при парковом — партнёр. От этого зависит график и способ вывода.'],
          ['Проверьте первую выплату на короткой смене', 'Сверьте сумму в приложении, удержания и фактическое поступление. Только после этого планируйте длинный график.'],
        ],
        source: {
          href: 'https://pro.yandex.ru/ru-ru/kotovo/knowledge-base/courier/dohod/payouts-every-day-couriers',
          label: 'Официальные условия быстрых выплат с картой Про',
        },
      },
      {
        anchor: 'transport',
        heading: 'Транспорт меняет экономику сильнее названия сервиса',
        items: [
          ['Пешком', 'Меньше прямых расходов, но сильнее влияют расстояние, вес и погода.'],
          ['Велосипед', 'Больше радиус и темп, но нужны исправная техника, заряд или физическая форма и безопасное хранение.'],
          ['Автомобиль', 'Проще на дальних маршрутах и в непогоду, но топливо, парковка и обслуживание вычитаются из выплаты.'],
        ],
      },
      {
        anchor: 'reshenie',
        heading: 'Как принять решение за один вечер',
        steps: [
          ['Проверьте оба сервиса в своём городе', 'Смотрите доступный район, формат транспорта и путь до первого выхода.'],
          ['Запишите обязательные расходы', 'Транспорт, связь, питание в дороге, налоги и дорога до зоны должны попасть в расчёт.'],
          ['Выберите один маршрут для теста', 'Не оформляйте всё одновременно. Пройдите регистрацию и короткую смену там, где понятнее условия и поддержка.'],
          ['Сравните по факту', 'После смены запишите время, нагрузку, расходы и поступление. Решение о продолжении станет проще.'],
        ],
      },
    ],
    next: [
      ['/dostavka', 'Вернуться к выбору формата курьера'],
      ['/eda', 'Проверить маршрут Яндекс Еды через ABG Taxi'],
      [`${EDARU_URL}/blog/eda-vs-kuper-2026`, 'Прочитать подробное сравнение Еды и Купера', 'edaru_read_more_click'],
    ],
    faq: [
      ['Почему страница Купера ведёт к Яндекс Еде?', 'ABG Taxi предлагает собственный маршрут подключения в Яндекс Еду. Страница сохраняет запрос Купера, чтобы вы могли сравнить варианты и заранее увидеть, куда ведёт кнопка.'],
      ['ABG Taxi — партнёр Купера?', 'Нет, на этой странице мы не заявляем партнёрство с Купером. Официальная страница Купера указана только как источник условий для сравнения.'],
      ['Где выплаты быстрее?', 'У Купера на публичной странице указан еженедельный график. В Яндекс Еде срок зависит от типа сотрудничества; прямые самозанятые с картой Про могут получать деньги после заказа.'],
      ['У кого лучше карта заказов?', 'Это стоит проверять в своём городе и районе. В Яндекс Про карта показывает зоны и информацию для доставок, но доступность заказов меняется по времени и спросу.'],
      ['Можно подключиться к Яндекс Еде на автомобиле?', 'Да, автомобиль — один из доступных способов доставки. Перед оформлением посчитайте топливо, парковку, обслуживание и путь обратно из зоны.'],
      ['Как не ошибиться с выбором?', 'Сравните один и тот же район, одинаковое доступное время и все расходы. Затем пройдите один маршрут и проверьте короткую смену вместо одновременной регистрации в нескольких сервисах.'],
    ],
  },
  {
    path: '/rabota',
    navLabel: 'Работа',
    title: 'Работа водителем или курьером через ABG Taxi',
    description: 'Сравните работу водителем, автокурьером, велокурьером и пешим курьером через ABG Taxi: документы, расходы, график и маршрут для первого выхода.',
    eyebrow: 'Работа · водитель или курьер',
    h1: 'Работа водителем или курьером: выберите свой маршрут',
    lead: 'Есть машина — сравните такси и автодоставку. Есть велосипед — посчитайте радиус и ремонт. Транспорта нет — начните с пешего формата. Сначала проверьте одну смену, потом решайте, подходит ли такая работа регулярно.',
    updated: 'Обновлено 11 августа 2026 года',
    layout: 'route',
    ctas: [
      { label: 'У меня есть автомобиль', href: '/taxi', event: 'route_select_taxi' },
      { label: 'Хочу начать с доставки', href: '/dostavka', event: 'route_select_courier', kind: 'secondary' },
    ],
    facts: [
      ['Водитель такси', 'пассажиры, требования к автомобилю и документам'],
      ['Автокурьер', 'заказы вместо пассажиров, но тот же пробег и расходы'],
      ['Пеший или вело', 'проще начать без машины, сильнее влияет погода'],
    ],
    instructionsEyebrow: 'Начните со своей ситуации',
    instructionsHeading: 'Что у вас уже есть?',
    instructions: [
      {
        number: '01',
        title: 'Есть автомобиль и водительские документы',
        text: 'Сравните перевозку пассажиров и доставку: требования, общение, пробег, парковку и чистый остаток.',
        href: '#est-avtomobil',
      },
      {
        number: '02',
        title: 'Есть велосипед или электровелосипед',
        text: 'Проверьте технику, безопасный маршрут, заряд и стоимость регулярного обслуживания.',
        href: '#est-velosiped',
      },
      {
        number: '03',
        title: 'Транспорта пока нет',
        text: 'Пеший формат позволяет проверить работу до аренды или покупки велосипеда.',
        href: '#bez-transporta',
      },
      {
        number: '04',
        title: 'Есть только несколько часов',
        text: 'Считайте дорогу до зоны и домой: короткое окно легко потерять ещё до первого заказа.',
        href: '#neskolko-chasov',
      },
      {
        number: '05',
        title: 'Нужна более регулярная работа',
        text: 'Проверьте формат на нескольких сопоставимых сменах и только потом увеличивайте часы.',
        href: '#testovaya-nedelya',
      },
    ],
    sections: [
      {
        anchor: 'est-avtomobil',
        heading: 'Есть автомобиль: такси или автодоставка?',
        lead: 'Оба формата используют машину, но рабочий день ощущается по-разному. В такси важны пассажиры и состояние салона. В доставке — парковка у ресторанов и домов, перенос заказов и пустой пробег между зонами.',
        items: [
          ['Такси', 'Подходит, если вы спокойно общаетесь с пассажирами, автомобиль проходит требования, а документы готовы к проверке.'],
          ['Автодоставка', 'Подходит, если вы предпочитаете заказы вместо пассажиров и готовы часто выходить из машины у ресторанов, магазинов и подъездов.'],
          ['Что посчитать', 'Топливо, мойку, парковку, комиссию, налоги, обслуживание и километры без заказа. Сумма в приложении — ещё не чистый результат.'],
        ],
        note: 'Для пассажирского маршрута откройте страницу «Работа в такси». Для автодоставки сначала сравните форматы на странице «Работа курьером».',
      },
      {
        anchor: 'est-velosiped',
        heading: 'Есть велосипед: проверьте не скорость, а повторяемость смены',
        lead: 'На велосипеде можно пройти больший радиус без топлива. Но работа перестанет быть дешёвой, если каждый день чинить проколы, искать заряд или оставлять транспорт без замка.',
        steps: [
          ['Проверьте тормоза, свет и колёса', 'Исправность важнее средней скорости. Для электровелосипеда добавьте заряд аккумулятора и запас на обратную дорогу.'],
          ['Выберите безопасный район', 'Первый выход лучше провести там, где вы знаете дороги, переходы и места для парковки.'],
          ['Запишите расходы после смены', 'Ремонт и расходники не списываются ежедневно, поэтому откладывайте часть результата на обслуживание.'],
        ],
      },
      {
        anchor: 'bez-transporta',
        heading: 'Транспорта нет: начните пешком и не берите аренду вслепую',
        lead: 'Пешая доставка даёт возможность понять приложение, районы и собственную нагрузку без фиксированной платы за аренду. Если формат подходит, транспорт можно выбирать уже по реальному маршруту.',
        steps: [
          ['Найдите компактную зону', 'Оцените путь до неё и наличие ресторанов или магазинов, а не только расстояние по прямой.'],
          ['Возьмите короткий первый выход', 'Проверьте обувь, погоду, вес заказов и сколько сил остаётся на дорогу домой.'],
          ['Не покупайте велосипед в первый день', 'Сначала поймите, какие расстояния встречаются именно у вас и где транспорт можно безопасно хранить.'],
        ],
      },
      {
        anchor: 'neskolko-chasov',
        heading: 'Есть несколько часов: защитите их от дороги и ожидания',
        lead: 'Короткая подработка имеет смысл, когда зона находится рядом и старт не съедает половину свободного времени. Иногда формат возле дома выгоднее более высокой ставки в другом конце города.',
        items: [
          ['До начала', 'Посчитайте дорогу до зоны, подготовку автомобиля или велосипеда и время на поиск парковки.'],
          ['Во время', 'Отделяйте выполнение заказов от ожидания. Оба периода занимают ваше время, даже если оплачиваются по-разному.'],
          ['После', 'Добавьте дорогу домой и восстановление. Если завтра основная работа, тяжёлая ночная смена может обойтись дороже выплаты.'],
        ],
      },
      {
        anchor: 'testovaya-nedelya',
        heading: 'Тестовая неделя вместо решения на эмоциях',
        lead: 'Одна удачная или неудачная смена мало что показывает. Проверьте один формат несколько раз в сопоставимое время и записывайте одинаковые показатели.',
        steps: [
          ['Выберите один формат', 'Не сравнивайте одновременно новый сервис, новый район и новый транспорт — вы не поймёте, что именно сработало.'],
          ['Проведите несколько похожих смен', 'Сравнивайте одинаковые дни и время, а не спокойный понедельник с дождливой пятницей.'],
          ['Записывайте четыре числа', 'Время от выхода из дома до возвращения, сумму в приложении, прямые расходы и чистый остаток.'],
          ['Отметьте нагрузку', 'Боль, раздражение и недосып — такие же данные. Работу должно быть возможно повторять без постоянного восстановления.'],
          ['Примите решение', 'Оставьте формат, смените район или транспорт либо вернитесь к другому маршруту. Покупки и аренду делайте после этой проверки.'],
        ],
      },
      {
        anchor: 'dokumenty',
        heading: 'Какие данные подготовить перед оформлением',
        lead: 'Точный пакет зависит от маршрута, города, возраста и гражданства. На первом шаге достаточно проверить доступ к телефону, качество документов и соответствие транспорта.',
        items: [
          ['Для водителя', 'Водительские документы, данные автомобиля и разрешение использовать его для работы. Окончательный список покажет Fleet-форма.'],
          ['Для курьера', 'Телефон, документы по запросу анкеты и транспорт, если вы выбрали вело- или автоформат.'],
          ['Для обоих маршрутов', 'Читайте договор и условия выплат до подтверждения. Коды входа, данные карты и документы не отправляйте в случайные чаты.'],
        ],
      },
    ],
    next: [
      ['/podrabotka', 'Если нужен короткий тестовый выход'],
      [`${EDARU_URL}/blog/rabota-v-dostavke-edy-2026`, 'Разобраться в работе в доставке еды', 'edaru_read_more_click'],
      ['/instructions', 'Сохранить инструкции для первого выхода'],
    ],
    faq: [
      ['Что выбрать: такси или доставку на автомобиле?', 'Такси подходит тем, кто готов работать с пассажирами и требованиями к салону. В доставке пассажиров нет, но остаются пробег, парковка, перенос заказов и расходы автомобиля.'],
      ['Можно начать без автомобиля?', 'Да. Для доставки можно рассмотреть пеший или велосипедный формат. Доступность конкретного варианта проверьте в своём городе.'],
      ['Стоит ли арендовать велосипед или машину сразу?', 'Сначала проверьте пешую или короткую тестовую смену и посчитайте реальный маршрут. Фиксированная аренда опасна, пока поток заказов и ваши силы не проверены.'],
      ['Можно совмещать с основной работой?', 'Да, если выбранный сервис и доступные слоты совпадают с вашим графиком. Считайте дорогу до зоны, возвращение домой и восстановление, а не только часы в приложении.'],
      ['Как считать чистый результат смены?', 'Из суммы в приложении вычтите топливо или транспорт, парковку, связь, питание в дороге, комиссию, налоги и резерв на обслуживание. Затем разделите остаток на всё время от выхода до возвращения.'],
      ['Как понять, что формат не подходит?', 'Если после нескольких сопоставимых смен чистый результат ниже вашей цели или нагрузку невозможно повторять, смените район, транспорт, время либо сам маршрут.'],
    ],
  },
  {
    path: '/instructions',
    navLabel: 'Инструкции',
    title: 'ABG Taxi: инструкции водителям и курьерам Яндекс Про',
    description: 'Инструкции ABG Taxi для водителей и курьеров: первый вход в Яндекс Про, профиль, выплаты, рейтинг, отсутствие заказов, термокороб и помощь парка онлайн.',
    eyebrow: 'Для действующих партнёров · без рекламы',
    h1: 'Выберите свою проблему в Яндекс Про',
    lead: 'Повторно регистрироваться не нужно. Найдите ситуацию ниже: первый вход, выплаты, отсутствие заказов, рейтинг, термокороб или активный заказ. Если экран выглядит иначе, здесь указано, кому написать и какие данные можно отправить безопасно.',
    updated: 'Обновлено 11 августа 2026 года',
    layout: 'instructions',
    ctas: [
      { label: 'Проверить профиль и выплаты', href: '/instructions/yandex-pro' },
      helpCta,
    ],
    instructionsHeading: 'С чем нужна помощь?',
    instructions: [
      {
        number: '01',
        title: 'Первый вход и профиль',
        text: 'Проверить телефон, город, автомобиль или способ доставки, доступные режимы и предупреждения до линии.',
        href: '/instructions/yandex-pro',
      },
      {
        number: '02',
        title: 'Выплаты и вывод денег',
        text: 'Посмотреть видео Лены и проверить баланс до обращения в парк.',
        href: '/instructions/yandex-pro#payout-video',
      },
      {
        number: '03',
        title: 'Я на линии, но заказов нет',
        text: 'Проверить диагностику, статус линии, доступные режимы, связь и ограничения профиля.',
        href: '#rating-orders',
      },
      {
        number: '04',
        title: 'Рейтинг или приоритет изменился',
        text: 'Не сравнивать цифры водителя и курьера; открыть показатель в своём профиле и проверить сообщения приложения.',
        href: '#rating-orders',
      },
      {
        number: '05',
        title: 'Нужно добавить термокороб',
        text: 'Проверить требования к коробу, включить опцию и пройти фотоконтроль в Яндекс Про.',
        href: '#thermobox',
      },
      {
        number: '06',
        title: 'Проблема с активным заказом',
        text: 'Сначала написать в поддержку внутри приложения — она видит заказ, адреса и текущий статус.',
        href: '#support',
      },
    ],
    facts: [
      ['Парк', 'помогает с подключением и профилем'],
      ['Поддержка сервиса', 'видит конкретный заказ и работу приложения'],
      ['Безопасность', 'не отправляйте CVV, коды из SMS и полные фото документов в чат'],
    ],
    sections: [
      {
        anchor: 'rating-orders',
        heading: 'Если вы на линии, но заказов нет',
        lead: 'Сначала исключите техническую причину, затем проверяйте спрос. Не нужно сразу менять район или переустанавливать приложение: Яндекс Про обычно показывает предупреждение, если профиль не готов принимать заказы.',
        steps: [
          ['Откройте предупреждение или диагностику', 'Если на главном экране есть сообщение о проверке или ограничении, откройте его и выполните указанные действия.'],
          ['Проверьте рабочий статус', 'Убедитесь, что вы действительно вышли на линию, а нужный тариф или способ доставки доступен в профиле.'],
          ['Проверьте телефон', 'Нужны мобильный интернет, геолокация, уведомления и заряд. Убедитесь, что телефон разрешает Яндекс Про работать в фоне.'],
          ['Сверьте баланс и профиль с парком', 'Если приложение указывает на парк, напишите ABG Taxi и уточните статус подключения или установленный лимит.'],
          ['Только затем оценивайте спрос', 'Когда предупреждений нет, сравните район, время и текущий спрос. Приоритет влияет на распределение заказов, но не гарантирует их поток.'],
        ],
        source: {
          href: 'https://pro.yandex.ru/ru-ru/otradnoe/knowledge-base/taxi/rides/net-zakazov',
          label: 'Официальная инструкция Яндекс Про: почему не приходят заказы',
        },
      },
      {
        heading: 'Рейтинг водителя и рейтинг курьера — не одно и то же',
        lead: 'У водителя такси в профиле есть рейтинг и приоритет. У курьера может отображаться своя система рейтинга и уровней, причём условия зависят от города. Поэтому чужой скриншот из другого сервиса или региона не объясняет ваш показатель.',
        items: [
          ['Водителю', 'Откройте профиль и сообщения Яндекс Про. Там видны актуальный рейтинг, доступные тарифы и действия, влияющие на приоритет в вашем городе.'],
          ['Курьеру', 'Смотрите раздел рейтинга и качества в своём приложении. Баллы, уровни и преимущества могут меняться по городу и периоду.'],
          ['Если показатель изменился', 'Проверьте уведомления после последних заказов. Парк не может вручную переписать оценку пользователя или правила сервиса.'],
        ],
        source: {
          href: 'https://pro.yandex.ru/ru-ru/moskva/knowledge-base/taxi/income-diff/new-priority',
          label: 'Официальная инструкция Яндекс Про: как работает приоритет водителя',
        },
      },
      {
        anchor: 'thermobox',
        heading: 'Как добавить термокороб в Яндекс Про',
        lead: 'Термокороб нужен для заказов с едой и продуктами. По действующей официальной инструкции короб должен быть чистым, целым, держать форму, иметь моющуюся внутреннюю поверхность и размеры не меньше 40 × 40 × 25 см.',
        steps: [
          ['Проверьте короб', 'Уберите личные вещи и посторонние наклейки. Внутри должно быть разделение, которое помогает не смешивать горячее и холодное, пищевые и непищевые товары.'],
          ['Откройте профиль', 'Перейдите в раздел «Опции для тарифов», выберите «Термокороб» и включите переключатель.'],
          ['Пройдите фотоконтроль', 'В профиле выберите «Фотоконтроль» → «Фотоконтроль термокороба» → «Пройти проверку». Следуйте рамке и подсказкам на экране.'],
          ['Проверьте результат', 'Не выходите на заказ с отметкой о коробе, пока опция и проверка не подтверждены в профиле.'],
        ],
        note: 'Требования и названия разделов могут обновляться. Если экран отличается, откройте свежую справку для своего города или отправьте парку обезличенный скриншот.',
        source: {
          href: 'https://pro.yandex.ru/ru-ru/kovrov/knowledge-base/delivery-foot/service-standards/zachem-nuzhen-termokorob-i-kak-ego-poluchit',
          label: 'Официальная инструкция Яндекс Про: термокороб и фотоконтроль',
        },
      },
      {
        anchor: 'support',
        heading: 'Кому написать, чтобы не пересказывать вопрос дважды',
        lead: 'Главное — отправить вопрос туда, где видны нужные данные. Парк помогает с подключением и профилем. Поддержка сервиса видит активный заказ, маршрут, начисление и действия в приложении.',
        items: [
          ['Заказ уже принят', 'Откройте поддержку внутри Яндекс Про. Укажите, что произошло сейчас, и следуйте ответу по конкретному заказу.'],
          ['Не тот парк, город или автомобиль', 'Напишите ABG Taxi: укажите город, номер телефона аккаунта текстом и приложите скриншот без личных данных.'],
          ['Не прошёл документ', 'Сначала уточните у парка безопасный способ передачи. Не отправляйте полную фотографию документа в общий чат.'],
          ['Не пришла выплата', 'Сверьте баланс и историю операций, затем укажите дату, сумму и тип операции. Данные карты, CVV и SMS-коды не нужны.'],
        ],
      },
    ],
    next: [
      ['/instructions/yandex-pro', 'Открыть профиль, первый выход и видео выплат'],
      ['/taxi', 'Проверить маршрут подключения водителя'],
      ['/dostavka', 'Выбрать пеший, велосипедный или автомобильный формат'],
    ],
    faq: [
      ['Почему после входа нет заказов?', 'Проверьте диагностику, рабочий статус, доступные тарифы или способы доставки, связь и сообщения приложения. Если причина относится к профилю парка, напишите ABG Taxi.'],
      ['Рейтинг и приоритет — это одно и то же?', 'Нет. У водителя рейтинг отражает оценки пользователей, а приоритет участвует в распределении заказов. У курьеров действует отдельная система, которая может различаться по городам.'],
      ['Можно ли добавить любой термокороб?', 'Короб должен соответствовать действующим требованиям сервиса и пройти фотоконтроль. Перед покупкой сравните размеры и устройство короба со свежей официальной инструкцией.'],
      ['Где включается термокороб?', 'В действующей версии инструкции: профиль → «Опции для тарифов» → «Термокороб». Если такого пункта нет, проверьте город, способ доставки и доступные опции или напишите парку.'],
      ['Кому писать по активному заказу?', 'Поддержке внутри приложения: она видит номер заказа, адреса и текущий статус. Парк помогает с подключением и профилем, но не видит всю историю активного заказа.'],
      ['Какие данные нельзя отправлять в чат?', 'Не передавайте SMS-коды, пароли, CVV, полный номер банковской карты и полные фотографии документов. Для начала достаточно города, телефона аккаунта текстом и обезличенного скриншота.'],
    ],
  },
  {
    path: '/instructions/yandex-pro',
    navLabel: 'Яндекс Про',
    title: 'Яндекс Про после подключения: профиль и первый выход',
    description: 'Что проверить в Яндекс Про после подключения через ABG Taxi: профиль, транспорт, статусы, поддержка и порядок действий перед первым заказом.',
    eyebrow: 'Инструкция · Яндекс Про',
    h1: 'Перед первым заказом проверьте профиль',
    lead: 'Не выходите на линию вслепую. Пять минут на проверку профиля помогают заметить неверный город, транспорт или недостающий статус до заказа.',
    layout: 'instructions',
    ctas: [helpCta],
    sections: [
      {
        heading: 'Проверка по порядку',
        steps: [
          'Откройте профиль и убедитесь, что ФИО и номер телефона ваши.',
          'Проверьте город, автомобиль или выбранный способ доставки.',
          'Посмотрите, какие статусы и проверки ещё не завершены.',
          'Разрешите только необходимые уведомления и геолокацию во время работы.',
          'Перед первым заказом проверьте баланс телефона и заряд устройства.',
        ],
      },
      {
        heading: 'Кому писать по проблеме',
        anchor: 'support',
        items: [
          ['Заказ уже принят', 'Используйте поддержку внутри приложения: она видит заказ, адреса и текущий статус.'],
          ['Не тот парк или профиль', 'Напишите ABG Taxi и укажите номер телефона аккаунта текстом.'],
          ['Ошибка документа', 'Не отправляйте документ в общий чат. Сначала уточните у парка безопасный способ передачи.'],
        ],
      },
    ],
    next: [
      ['/instructions', 'Открыть все инструкции'],
      ['/about', 'Контакты и реквизиты ABG Taxi'],
    ],
    faq: [
      ['Почему нет заказов сразу после входа?', 'Проверьте завершение проверок, активный статус, выбранный район и сообщения приложения. Конкретную причину по аккаунту видит поддержка сервиса.'],
      ['Можно отправить код из SMS менеджеру?', 'Нет. Коды подтверждения, CVV и пароли нельзя передавать никому, включая чат парка.'],
    ],
  },
  {
    path: '/uz',
    navLabel: 'O‘zbekcha',
    title: 'ABG Taxi: haydovchilar uchun ulanish yo‘riqnomasi',
    description: 'ABG Taxi orqali haydovchi sifatida ulanish: kerakli hujjatlar, Fleet anketasi va ro‘yxatdan o‘tgandan keyingi aniq qadamlar.',
    eyebrow: 'ABG Taxi · O‘zbekcha qisqa yo‘riqnoma',
    h1: 'Haydovchi sifatida ulanish tartibi',
    lead: 'Bu Yandex sayti emas, ABG Taxi hamkorining sayti. Anketani to‘ldirishdan oldin shahar, avtomobil va hujjatlaringizni tekshiring.',
    layout: 'route',
    ctas: [
      { ...fleetCta, label: 'Ulanish anketasini ochish' },
      { ...helpCta, label: 'ABG Taxi’ga yozish' },
    ],
    facts: [
      ['Operator', 'OOO «AB GROUP»'],
      ['Kerak bo‘ladi', 'pasport, haydovchilik guvohnomasi va avtomobil hujjatlari'],
      ['Muhim', 'SMS kodi, parol va CVV kodini hech kimga bermang'],
    ],
    sections: [
      {
        heading: 'To‘rt qadam',
        steps: [
          'Shahar va ishlash turini tanlang.',
          'Hujjatlardagi ma’lumotlarni xatosiz kiriting.',
          'Fleet anketasini yuboring va tekshiruv javobini kuting.',
          'Ishni boshlashdan oldin Yandex Pro profilini tekshiring.',
        ],
      },
    ],
    next: [
      ['/instructions/yandex-pro', 'Yandex Pro yo‘riqnomasi (rus tilida)'],
      ['/about', 'ABG Taxi kontaktlari'],
    ],
  },
  {
    path: '/about',
    navLabel: 'О парке',
    title: 'О парке ABG Taxi — контакты и реквизиты',
    description: 'ABG Taxi — партнёрский парк ООО «АБ ГРУПП». Проверенные реквизиты, контакты, роль парка и способы связи для водителей и курьеров.',
    eyebrow: 'Оператор сайта · ООО «АБ ГРУПП»',
    h1: 'ABG Taxi подключает и помогает партнёрам',
    lead: 'Мы отделяем роль парка от роли сервисов. Парк отвечает за свой маршрут подключения и помощь с профилем; за приложение, заказы и правила конкретного сервиса отвечает его поддержка.',
    layout: 'about',
    facts: [
      ['ИНН', '7805757269'],
      ['ОГРН', '1197847201970'],
      ['Адрес', 'Санкт-Петербург, ул. Ивана Черных, д. 20, литера А, помещ. 101'],
    ],
    sections: [
      {
        heading: 'Как быстрее получить помощь',
        steps: [
          'Укажите город и выбранный формат работы.',
          'Опишите, на каком шаге возникла проблема.',
          'Приложите скриншот без паспортных данных, банковских реквизитов и кодов.',
          'Если проблема относится к активному заказу, используйте поддержку внутри приложения.',
        ],
      },
    ],
    ctas: [helpCta, { label: 'Написать в WhatsApp', href: 'https://wa.me/79112884344', event: 'whatsapp_click', external: true, kind: 'secondary' }],
    next: [
      ['/offer', 'Оферта'],
      ['/privacy', 'Политика обработки данных'],
    ],
    faq: [
      ['ABG Taxi работает только в Петербурге?', 'Юридический адрес находится в Санкт-Петербурге, а доступность подключения зависит от выбранного сервиса и города.'],
      ['Где проверить реквизиты?', 'ИНН и ОГРН указаны на этой странице и в юридических документах сайта.'],
    ],
  },
  {
    path: '/offer',
    navLabel: 'Оферта',
    title: 'Оферта ООО «АБ ГРУПП» — ABG Taxi',
    description: 'Публичная оферта ООО «АБ ГРУПП» для пользователей и партнёров ABG Taxi: условия, порядок взаимодействия и реквизиты оператора.',
    eyebrow: 'Юридический документ · ООО «АБ ГРУПП»',
    h1: 'Публичная оферта ООО «АБ ГРУПП»',
    lead: 'Прочитайте условия взаимодействия с ООО «АБ ГРУПП» до подключения. Если в документе непонятен пункт, уточните его у парка до подтверждения.',
    layout: 'legal',
    legalKey: 'offer',
  },
  {
    path: '/privacy',
    navLabel: 'Политика',
    title: 'Политика обработки персональных данных ABG Taxi',
    description: 'Политика обработки и защиты персональных данных на сайте ABG Taxi. Оператор персональных данных — ООО «АБ ГРУПП», ИНН 7805757269.',
    eyebrow: 'Персональные данные · ООО «АБ ГРУПП»',
    h1: 'Политика обработки персональных данных',
    lead: 'Здесь описано, какие данные может обрабатывать ООО «АБ ГРУПП» и какие права есть у пользователя. Сайт не просит паспортные или банковские данные в собственных формах.',
    layout: 'legal',
    legalKey: 'privacy',
  },
]

export const pageMap = new Map(pages.map((page) => [page.path, page]))
export const canonicalPaths = pages.map((page) => page.path)

export function normalizePath(input = '/') {
  const path = input.split('?')[0].split('#')[0] || '/'
  if (path === '/') return '/'
  return path.replace(/\/+$/, '') || '/'
}

export function getPage(input) {
  return pageMap.get(normalizePath(input)) || null
}
